import React from 'react';
import './Error.css';

interface ErrorProps {
    error: {
        message: string;
    };
}

export const Error = (props: ErrorProps): React.ReactElement => {
    const { message } = props.error;

    return <div>Error: {message}</div>;
};
